var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWavedesign(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 230,
    height: 95,
    viewBox: "0 0 230 95",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_91_2405)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M182.134 -42.2096C202.665 -33.6391 220.946 -31.9025 227.521 -32.1055L245.639 149.631L20.1021 172.116L13.209 102.976C73.6196 106.454 97.6146 50.3718 106.003 5.79901C114.392 -38.7738 156.47 -52.9227 182.134 -42.2096Z",
    fill: "url(#paint0_linear_91_2405)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M217.827 -15.5399C232.915 -16.0498 254.087 -19.0885 263.409 -20.4973L289 112.211L33.968 132.743L30.622 115.391C39.9043 116.601 68.5811 114.937 109.03 98.6046C159.592 78.1896 147.909 42.1018 153.207 12.4184C158.505 -17.2649 198.967 -14.9025 217.827 -15.5399Z",
    fill: "url(#paint1_linear_91_2405)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M245.646 46.6828C169.864 67.8163 173.378 139.809 184.608 173.163L275.759 74.5042L245.646 46.6828Z",
    fill: "url(#paint2_linear_91_2405)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_91_2405",
    x1: 159.655,
    y1: -228.646,
    x2: 190.829,
    y2: 73.9836,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_91_2405",
    x1: 237.279,
    y1: -286.078,
    x2: 233.898,
    y2: 159.743,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_91_2405",
    x1: 230.35,
    y1: -211.48,
    x2: 325.379,
    y2: 105.403,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_91_2405"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 230,
    height: 95,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWavedesign);
export default __webpack_public_path__ + "static/media/Wavedesign.f1d9aa52d1381a4fbe47d8d8526c6ef1.svg";
export { ForwardRef as ReactComponent };